const actionTypes = {

  // * actions za app reducer (i app state)

  DEV_ULOGUJ: 'ULOGUJ',
  SUBMIT_ULOGUJ: 'SUBMIT_ULOGUJ',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGIN_FETCHING: 'LOGIN_FETCHING',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  AUTOLOGIN: 'AUTOLOGIN',
  SHOW_TOAST: 'SHOW_TOAST',
  CLOSE_TOAST: 'CLOSE_TOAST',
  ANIMATED_CLOSING_TOAST: 'ANIMATED_CLOSING_TOAST',
  SHOW_MODAL: 'SHOW_MODAL',
  ANIMATED_CLOSE_MODAL: 'ANIMATED_CLOSE_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  ROUTE_SET: 'ROUTE_SET',
  ROUTE_WITH_PARAMS_SET: 'ROUTE_WITH_PARAMS_SET',
  ROUTE_REFRESH: 'ROUTE_REFRESH',
  ROUTE_SECOND_SCREEN_CLOSE: 'ROUTE_SECOND_SCREEN_CLOSE',
  SPINNER_GLOBAL_SHOW: 'SPINNER_GLOBAL_SHOW',
  SPINNER_GLOBAL_HIDE: 'SPINNER_GLOBAL_HIDE',

  CHEATS_ENABLE: 'CHEATS_ENABLE',

  ADMIN_SIMDB_GET_WHOLE_FETCHING: 'ADMIN_SIMDB_GET_WHOLE_FETCHING',
  ADMIN_SIMDB_GET_WHOLE_FETCHED: 'ADMIN_SIMDB_GET_WHOLE_FETCHED',

  INITIALIZED_INITIAL_SETTINGS: 'INITIALIZED_INITIAL_SETTINGS', // App ready to start
  INITIALIZED_VIRTEL_SCHEMA_OPTIMIZED: 'INITIALIZED_VIRTEL_SCHEMA_OPTIMIZED',
  INITIALIZED_LIB_TER_CONST: 'INITIALIZED_LIB_TER_CONST',
  INITIALIZED_LIB_VIRTEL_PARAMS: 'INITIALIZED_LIB_VIRTEL_PARAMS',
  INITIALIZED_LIB_MATERIJAL_LIM: 'INITIALIZED_LIB_MATERIJAL_LIM',
  INITIALIZED_LIB_CNC_S4_TEMPLATE: 'INITIALIZED_LIB_CNC_S4_TEMPLATE',
  INITIALIZED_LIB_DOCUMENT: 'INITIALIZED_LIB_DOCUMENT',
  INITIALIZED_LIB_CPARAMS: 'INITIALIZED_LIB_CPARAMS',
  INITIALIZED_ALL: 'INITIALIZED_ALL',

  LIB_VIRTEL_PARAMS_LIST_FETCHING: 'LIB_VIRTEL_PARAMS_LIST_FETCHING',
  LIB_VIRTEL_PARAMS_LIST_SUCCESS: 'LIB_VIRTEL_PARAMS_LIST_SUCCESS',
  LIB_VIRTEL_PARAMS_LIST_FAIL: 'LIB_VIRTEL_PARAMS_LIST_FAIL',
  LIB_VIRTEL_PARAMS_LIST_CATCH: 'LIB_VIRTEL_PARAMS_LIST_CATCH',

  LIB_MATERIJAL_LIM_LIST_FETCHING: 'LIB_MATERIJAL_LIM_LIST_FETCHING',
  LIB_MATERIJAL_LIM_LIST_SUCCESS: 'LIB_MATERIJAL_LIM_LIST_SUCCESS',
  LIB_MATERIJAL_LIM_LIST_FAIL: 'LIB_MATERIJAL_LIM_LIST_FAIL',
  LIB_MATERIJAL_LIM_LIST_CATCH: 'LIB_MATERIJAL_LIM_LIST_CATCH',

  LIB_CNC_S4_TEMPLATE_LIST_FETCHING: 'LIB_CNC_S4_TEMPLATE_LIST_FETCHING',
  LIB_CNC_S4_TEMPLATE_LIST_SUCCESS: 'LIB_CNC_S4_TEMPLATE_LIST_SUCCESS',
  LIB_CNC_S4_TEMPLATE_LIST_FAIL: 'LIB_CNC_S4_TEMPLATE_LIST_FAIL',
  LIB_CNC_S4_TEMPLATE_LIST_CATCH: 'LIB_CNC_S4_TEMPLATE_LIST_CATCH',

  LIB_DOCUMENT_LIST_FETCHING: 'LIB_DOCUMENT_LIST_FETCHING',
  LIB_DOCUMENT_LIST_SUCCESS: 'LIB_DOCUMENT_LIST_SUCCESS',
  LIB_DOCUMENT_LIST_FAIL: 'LIB_DOCUMENT_LIST_FAIL',
  LIB_DOCUMENT_LIST_CATCH: 'LIB_DOCUMENT_LIST_CATCH',

  LIB_CPARAMS_LIST_FETCHING: 'LIB_CPARAMS_LIST_FETCHING',
  LIB_CPARAMS_LIST_SUCCESS: 'LIB_CPARAMS_LIST_SUCCESS',
  LIB_CPARAMS_LIST_FAIL: 'LIB_CPARAMS_LIST_FAIL',
  LIB_CPARAMS_LIST_CATCH: 'LIB_CPARAMS_LIST_CATCH',

  GENERAL_DATA_FETCHING: 'GENERAL_DATA_FETCHING',
  GENERAL_DATA_SUCCESS: 'GENERAL_DATA_SUCCESS',
  GENERAL_DATA_FAIL: 'GENERAL_DATA_FAIL',
  GENERAL_DATA_CATCH: 'GENERAL_DATA_CATCH',

  AUTH_FORMLOGIN_FETCHING: 'AUTH_FORMLOGIN_FETCHING',
  AUTH_FORMLOGIN_SUCCESS: 'AUTH_FORMLOGIN_SUCCESS',
  AUTH_FORMLOGIN_FAIL: 'AUTH_FORMLOGIN_FAIL',
  AUTH_FORMLOGIN_CATCH: 'AUTH_FORMLOGIN_CATCH',

  AUTH_AUTOLOGIN_FETCHING: 'AUTH_AUTOLOGIN_FETCHING',
  AUTH_AUTOLOGIN_SUCCESS: 'AUTH_AUTOLOGIN_SUCCESS',
  AUTH_AUTOLOGIN_FAIL: 'AUTH_AUTOLOGIN_FAIL',
  AUTH_AUTOLOGIN_CATCH: 'AUTH_AUTOLOGIN_CATCH',

  OBAVESTENJA_SUPERVALIDATOR: 'OBAVESTENJA_SUPERVALIDATOR',

  USER_LIST_FETCHING: 'USER_LIST_FETCHING',
  USER_LIST_SUCCESS: 'USER_LIST_SUCCESS',
  USER_LIST_FAIL: 'USER_LIST_FAIL',
  USER_LIST_CATCH: 'USER_LIST_CATCH',

  USER_CREATE_FETCHING: 'USER_CREATE_FETCHING',
  USER_CREATE_SUCCESS: 'USER_CREATE_SUCCESS',
  USER_CREATE_FAIL: 'USER_CREATE_FAIL',
  USER_CREATE_CATCH: 'USER_CREATE_CATCH',

  USER_UPDATE_FETCHING: 'USER_UPDATE_FETCHING',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  USER_UPDATE_FAIL: 'USER_UPDATE_FAIL',
  USER_UPDATE_CATCH: 'USER_UPDATE_CATCH',

  COMORDER_LOAD: 'COMORDER_LOAD',
  COMORDER_UNLOAD: 'COMORDER_UNLOAD',

  COMORDER_LIST_FETCHING: 'COMORDER_LIST_FETCHING',
  COMORDER_LIST_SUCCESS: 'COMORDER_LIST_SUCCESS',
  COMORDER_LIST_FAIL: 'COMORDER_LIST_FAIL',
  COMORDER_LIST_CATCH: 'COMORDER_LIST_CATCH',

  COMORDER_CREATE_FETCHING: 'COMORDER_CREATE_FETCHING',
  COMORDER_CREATE_SUCCESS: 'COMORDER_CREATE_SUCCESS',
  COMORDER_CREATE_FAIL: 'COMORDER_CREATE_FAIL',
  COMORDER_CREATE_CATCH: 'COMORDER_CREATE_CATCH',

  COMORDER_FLAGDELETED_FETCHING: 'COMORDER_FLAGDELETED_FETCHING',
  COMORDER_FLAGDELETED_SUCCESS: 'COMORDER_FLAGDELETED_SUCCESS',
  COMORDER_FLAGDELETED_FAIL: 'COMORDER_FLAGDELETED_FAIL',
  COMORDER_FLAGDELETED_CATCH: 'COMORDER_FLAGDELETED_CATCH',

  COMORDER_UNDELETE_FETCHING: 'COMORDER_UNDELETE_FETCHING',
  COMORDER_UNDELETE_SUCCESS: 'COMORDER_UNDELETE_SUCCESS',
  COMORDER_UNDELETE_FAIL: 'COMORDER_UNDELETE_FAIL',
  COMORDER_UNDELETE_CATCH: 'COMORDER_UNDELETE_CATCH',

  COMORDER_UPDATE_FETCHING: 'COMORDER_UPDATE_FETCHING',
  COMORDER_UPDATE_SUCCESS: 'COMORDER_UPDATE_SUCCESS',
  COMORDER_UPDATE_FAIL: 'COMORDER_UPDATE_FAIL',
  COMORDER_UPDATE_CATCH: 'COMORDER_UPDATE_CATCH',

  COMORDITEM_LOAD: 'COMORDITEM_LOAD',
  COMORDITEM_UNLOAD: 'COMORDITEM_UNLOAD',

  COMORDITEM_LIST_FETCHING: 'COMORDITEM_LIST_FETCHING',
  COMORDITEM_LIST_SUCCESS: 'COMORDITEM_LIST_SUCCESS',
  COMORDITEM_LIST_FAIL: 'COMORDITEM_LIST_FAIL',
  COMORDITEM_LIST_CATCH: 'COMORDITEM_LIST_CATCH',

  COMORDITEM_CREATE_FETCHING: 'COMORDITEM_CREATE_FETCHING',
  COMORDITEM_CREATE_SUCCESS: 'COMORDITEM_CREATE_SUCCESS',
  COMORDITEM_CREATE_FAIL: 'COMORDITEM_CREATE_FAIL',
  COMORDITEM_CREATE_CATCH: 'COMORDITEM_CREATE_CATCH',

  COMORDITEM_UPDATE_FETCHING: 'COMORDITEM_UPDATE_FETCHING',
  COMORDITEM_UPDATE_SUCCESS: 'COMORDITEM_UPDATE_SUCCESS',
  COMORDITEM_UPDATE_FAIL: 'COMORDITEM_UPDATE_FAIL',
  COMORDITEM_UPDATE_CATCH: 'COMORDITEM_UPDATE_CATCH',

  COMORDITEM_FLAGDELETED_FETCHING: 'COMORDITEM_FLAGDELETED_FETCHING',
  COMORDITEM_FLAGDELETED_SUCCESS: 'COMORDITEM_FLAGDELETED_SUCCESS',
  COMORDITEM_FLAGDELETED_FAIL: 'COMORDITEM_FLAGDELETED_FAIL',
  COMORDITEM_FLAGDELETED_CATCH: 'COMORDITEM_FLAGDELETED_CATCH',

  COMORDITEM_UNDELETE_FETCHING: 'COMORDITEM_UNDELETE_FETCHING',
  COMORDITEM_UNDELETE_SUCCESS: 'COMORDITEM_UNDELETE_SUCCESS',
  COMORDITEM_UNDELETE_FAIL: 'COMORDITEM_UNDELETE_FAIL',
  COMORDITEM_UNDELETE_CATCH: 'COMORDITEM_UNDELETE_CATCH',

  EXTERNAL_FILES_LIST_FETCHING: 'EXTERNAL_FILES_LIST_FETCHING',
  EXTERNAL_FILES_LIST_SUCCESS: 'EXTERNAL_FILES_LIST_SUCCESS',
  EXTERNAL_FILES_LIST_FAIL: 'EXTERNAL_FILES_LIST_FAIL',
  EXTERNAL_FILES_LIST_CATCH: 'EXTERNAL_FILES_LIST_CATCH',

  EXTERNAL_SPREADSHEET_UPLOAD_FETCHING: 'EXTERNAL_SPREADSHEET_UPLOAD_FETCHING',
  EXTERNAL_SPREADSHEET_UPLOAD_SUCCESS: 'EXTERNAL_SPREADSHEET_UPLOAD_SUCCESS',
  EXTERNAL_SPREADSHEET_UPLOAD_FAIL: 'EXTERNAL_SPREADSHEET_UPLOAD_FAIL',
  EXTERNAL_SPREADSHEET_UPLOAD_CATCH: 'EXTERNAL_SPREADSHEET_UPLOAD_CATCH',

  GENUS_PP_LIST_FETCHING: 'GENUS_PP_LIST_FETCHING',
  GENUS_PP_LIST_SUCCESS: 'GENUS_PP_LIST_SUCCESS',
  GENUS_PP_LIST_FAIL: 'GENUS_PP_LIST_FAIL',
  GENUS_PP_LIST_CATCH: 'GENUS_PP_LIST_CATCH',

  GENUS_PP_CREATE_FETCHING: 'GENUS_PP_CREATE_FETCHING',
  GENUS_PP_CREATE_SUCCESS: 'GENUS_PP_CREATE_SUCCESS',
  GENUS_PP_CREATE_FAIL: 'GENUS_PP_CREATE_FAIL',
  GENUS_PP_CREATE_CATCH: 'GENUS_PP_CREATE_CATCH',

  GENUS_IDENT_LIST_FETCHING: 'GENUS_IDENT_LIST_FETCHING',
  GENUS_IDENT_LIST_SUCCESS: 'GENUS_IDENT_LIST_SUCCESS',
  GENUS_IDENT_LIST_FAIL: 'GENUS_IDENT_LIST_FAIL',
  GENUS_IDENT_LIST_CATCH: 'GENUS_IDENT_LIST_CATCH',

  // NOVO
  VIRBOM_SINGLE_FETCHING: 'VIRBOM_SINGLE_FETCHING',
  VIRBOM_SINGLE_FAIL: 'VIRBOM_SINGLE_FAIL',
  VIRBOM_SINGLE_CATCH: 'VIRBOM_SINGLE_CATCH',
  VIRBOM_SINGLE_SUCCESS: 'VIRBOM_SINGLE_SUCCESS',
  DRAFT_UNLOAD: 'DRAFT_UNLOAD',
  DRAFT_LOAD: 'DRAFT_LOAD',
  DRAFT_LOAD_VIRBOM_IS_BLANK: 'DRAFT_LOAD_VIRBOM_IS_BLANK',
  DRAFT_LOAD_READ_ONLY: 'DRAFT_LOAD_READ_ONLY',
  DRAFT_LOAD_BLANK: 'DRAFT_LOAD_BLANK',
  DRAFT_LOAD_IMPORTED_SMARTBOM: 'DRAFT_LOAD_IMPORTED_SMARTBOM',
  DRAFT_REFRESH_SMARTBOM: 'DRAFT_REFRESH_SMARTBOM',

  DRAFT_REDUCER_RESPONSE_CREATE: 'DRAFT_REDUCER_RESPONSE_CREATE',

  // NOVO TODO boljeime smisliti
  DRAFT_SAVETODB_FETCHING: 'DRAFT_SAVETODB_FETCHING',
  DRAFT_SAVETODB_FAIL: 'DRAFT_SAVETODB_FAIL',
  DRAFT_SAVETODB_CATCH: 'DRAFT_SAVETODB_CATCH',
  DRAFT_SAVETODB_SUCCESS: 'DRAFT_SAVETODB_SUCCESS',

  // * actions za draft reducer (i draft state)

  DRAFT_INIT: 'DRAFT_INIT',

  DRAFT_KLIMA_KOMORA_DODAJ: 'DRAFT_KLIMA_KOMORA_DODAJ',
  DRAFT_KLIMA_KOMORA_IZMENI: 'DRAFT_KLIMA_KOMORA_IZMENI',
  DRAFT_KLIMA_KOMORA_DUPLIRAJ: 'DRAFT_KLIMA_KOMORA_DUPLIRAJ',
  DRAFT_KLIMA_KOMORA_OBRISI: 'DRAFT_KLIMA_KOMORA_OBRISI',

  DRAFT_MODUL_DODAJ: 'DRAFT_MODUL_DODAJ',
  DRAFT_MODUL_IZMENI: 'DRAFT_MODUL_IZMENI',
  DRAFT_MODUL_DUPLIRAJ: 'DRAFT_MODUL_DUPLIRAJ',
  DRAFT_MODUL_OBRISI: 'DRAFT_MODUL_OBRISI',

  DRAFT_POLUPROIZVOD_DODAJ: 'DRAFT_POLUPROIZVOD_DODAJ',
  DRAFT_POLUPROIZVOD_IZMENI: 'DRAFT_POLUPROIZVOD_IZMENI',
  DRAFT_POLUPROIZVOD_DUPLIRAJ: 'DRAFT_POLUPROIZVOD_DUPLIRAJ',
  DRAFT_POLUPROIZVOD_OBRISI: 'DRAFT_POLUPROIZVOD_OBRISI',

  DRAFT_MATERIJALCUSTOM_DODAJ: 'DRAFT_MATERIJALCUSTOM_DODAJ',
  DRAFT_MATERIJALCUSTOM_IZMENI: 'DRAFT_MATERIJALCUSTOM_IZMENI',
  DRAFT_MATERIJALCUSTOM_DUPLIRAJ: 'DRAFT_MATERIJALCUSTOM_DUPLIRAJ',
  DRAFT_MATERIJALCUSTOM_OBRISI: 'DRAFT_MATERIJALCUSTOM_OBRISI',
  DRAFT_MATERIJALCUSTOM_DODAJ_BULK: 'DRAFT_MATERIJALCUSTOM_DODAJ_BULK',

  DRAFT_SMARTEL_ENABLE: 'DRAFT_SMARTEL_ENABLE',

  DRAFT_SMARTEL_CPARAMS_OWN_UPSERT: 'DRAFT_SMARTEL_CPARAMS_OWN_UPSERT',

  DRAFT_SUPERVALIDATOR_ALL: 'DRAFT_SUPERVALIDATOR_ALL',

  // 'CLICKED_ON_MODUL_WIDGET' // TODO
  DRAFT_CLICKED_POZICIONIRAJ_MODUL_WIDGET: 'DRAFT_CLICKED_POZICIONIRAJ_MODUL_WIDGET',

};

export default actionTypes;
